<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"
	[template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<div class="app-content content">
	<div class="content-wrapper">
		<div class="content-detached">
			<div class="content-body">
				<div class="row">
					<div *ngIf="planActual && chartOptions" class="col-12">
						<div class="card card-custom gutter-b">
							<div class="card-header">
								<div class="card-title">
									<span class="card-icon">
										<i class="flaticon2-chat-1 text-primary"></i>
									</span>
									<h3 class="card-label">Tu plan <small> Aquí encuentras toda la información de tu
											plan</small></h3>
								</div>
								<div class="card-toolbar">
									<div *ngIf="planActual.pagado"
										class="btn btn-sm btn-text btn-success font-weight-bold mr-2"
										style="cursor: default">Pagado <i class="fa-regular fa-id-badge"></i></div>
									<div *ngIf="!planActual.pagado"
										class="btn btn-sm btn-text btn-light-danger font-weight-bold mr-2"
										(click)="payPlan(payPlanForm)" id="pendienteDePago">Pendiente de Pago <i
											class="fa-regular fa-id-badge"></i></div>

									<button *ngIf="planActual.pagado" id="extenderPlan"
										class="btn btn-sm btn-text font-weight-bold btn-outline-primary ml-5 mr-1"
										(click)="extendPlan(extendPlanForm)">
										<i class="fa-duotone fa-sack-dollar"></i>
										Extender Plan
									</button>
									<button *ngIf="planActual.pagado" id="nuevoPlan"
										class="btn btn-sm btn-text font-weight-bold btn-outline-info mr-5"
										(click)="changePlan(changePlanForm)">
										<i class="fa-regular fa-bolt"></i>
										Nuevo Plan
									</button>
									<ng-select class="comboEmpresa" [items]="rowsPlanes" [clearable]="false"
										(change)="filtro($event)" placeholder="Seleccione Empresa"
										bindLabel="nombreCompleto" [(ngModel)]="planActual">
										<!-- <option *ngFor="let option of rowsPlanes" [value]="option"></option> -->
									</ng-select>
								</div>
							</div>
							<div class="card-body">
								<div class="d-flex">
									<!--begin: Info-->
									<div class="flex-grow-1">
										<!--begin: Title-->
										<div class="d-flex align-items-center justify-content-between flex-wrap">
											<div class="mr-3">
												<!--begin::Name-->
												<a href="#"
													class="d-flex align-items-center text-dark text-hover-primary font-size-h5 font-weight-bold mr-3">{{
													planActual.nombreEmpresa }} | Plan: {{ planActual.nombrePlan }}<i
														class="flaticon2-correct text-success icon-md ml-2"></i></a>
												<!--end::Name-->
												<!--begin::Contacts-->
												<div class="d-flex flex-wrap my-2">
													<a href="#"
														class="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
														<i class="fa-regular fa-id-badge"></i>
														{{ planActual.rutEmpresa }}</a>
													<a href="#"
														class="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
														<i class="fa-regular fa-at mr-1"></i>{{ planActual.correoEmpresa
														}}</a>
													<a href="#"
														class="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
														<i class="fa-solid fa-wave-pulse"></i>{{ planActual.giroEmpresa
														}}</a>
												</div>
												<!--end::Contacts-->
											</div>
										</div>
										<!--end: Title-->
										<!--begin: Content-->
										<div class="row content-tuPlan">
											<div class="col-4">
												<apx-chart 
													[series]="chartOptions.series" 
													[chart]="chartOptions.chart" 
													[xaxis]="chartOptions.xaxis"
													[dataLabels]="chartOptions.dataLabels" 
													[stroke]="chartOptions.stroke" 
													[title]="chartOptions.title">
												</apx-chart>
											</div>
											<div class="col-6">
												<div class="d-flex flex-wrap align-items-center py-2">
													<div class="d-flex align-items-center mr-10 text-validacion" style="flex-grow: 2">
														<div class="mr-6">
															<div class="font-weight-bold mb-2">Válido Desde</div>
															<span
																class="btn btn-sm btn-text btn-light-primary text-uppercase font-weight-bold">{{
																planActual.fechaContratacion | date : "dd/MM/y"
																}}</span>
														</div>
														<div class="">
															<div class="font-weight-bold mb-2">Válido Hasta</div>
															<span
																class="btn btn-sm btn-text btn-light-danger text-uppercase font-weight-bold">{{
																planActual.fechaCaducidad | date : "dd/MM/y" }}</span>
														</div>
													</div>
													<div
														class="flex-grow-1 flex-shrink-1 w-150px w-xl-300px mt-4 mt-sm-0 uso_dte">
														<span class="font-weight-bold">Uso DTE del mes actual:</span>
														<span class="font-weight-bolder text-dark ml-3">{{
															planActual.currentDte | number : "1." }} / {{
															planActual.maxDte | number : "1." }} ({{ (100 *
															planActual.currentDte) / planActual.maxDte }}%)</span>
														<div class="progress progress-xs mt-2 mb-2"
															*ngIf="planActual.maxDte != -1">
															<div class="progress-bar bg-success" role="progressbar"
																[style.width.%]="(100 * planActual.currentDte) / planActual.maxDte"
																aria-valuenow="10" aria-valuemin="0"
																aria-valuemax="100"></div>
														</div>
														<br />
														<span class="font-weight-bold mt-3">Uso BHE del mes
															actual:</span>
														<span class="font-weight-bolder text-dark ml-3">{{
															planActual.currentBhe | number : "1." }} / {{
															planActual.maxBhe | number : "1." }} ({{ (100 *
															planActual.currentBhe) / planActual.maxBhe }}%)</span>
														<div class="progress progress-xs mt-2 mb-2">
															<div class="progress-bar bg-success" role="progressbar"
																[style.width.%]="(100 * planActual.currentBhe) / planActual.maxBhe"
																aria-valuenow="10" aria-valuemin="0"
																aria-valuemax="100"></div>
														</div>
													</div>
												</div>
											</div>
											<div class="col-2" 
												*ngIf="planActual.logoEmpresa">
												<img alt="logo"
													[src]="'data:image/png;base64,' + planActual.logoEmpresa"
													class="fill" />
											</div>
										</div>
										<!--end: Content-->
									</div>
									<!--end: Info-->
								</div>

								<div class="separator separator-solid my-7"></div>
								<!--begin: Items-->
								<div class="d-flex align-items-center flex-wrap">
									<!--begin: Item-->
									<div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
										<span class="mr-4">
											<i class="fa-light fa-file-invoice icon-2x"></i>
										</span>
										<div class="d-flex flex-column text-dark-75">
											<span class="font-weight-bolder font-size-sm">DTEs</span>
											<span class="font-weight-bolder font-size-h5"> <span
													class="text-dark-50 font-weight-bold">$</span>{{
												planActual.totalDineroDte | number : "1." }}</span>
										</div>
									</div>
									<!--end: Item-->
									<!--begin: Item-->
									<div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
										<span class="mr-4">
											<i class="fa-light fa-handshake icon-2x text-muted font-weight-bold"></i>
										</span>
										<div class="d-flex flex-column text-dark-75">
											<span class="font-weight-bolder font-size-sm">Boletas de Honorarios</span>
											<span class="font-weight-bolder font-size-h5"> <span
													class="text-dark-50 font-weight-bold">$</span>{{
												planActual.totalDineroBhe | number : "1." }}</span>
										</div>
									</div>
									<!--end: Item-->
									<!--begin: Item-->
									<div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
										<span class="mr-4">
											<i class="fa-duotone fa-tags icon-2x text-muted font-weight-bold"></i>
										</span>
										<div class="d-flex flex-column text-dark-75">
											<span class="font-weight-bolder font-size-sm">Valor del Plan</span>
											<span class="font-weight-bolder font-size-h5"> <span
													class="text-dark-50 font-weight-bold">$</span>{{
												planActual.pagoMensual | number : "1." }}</span>
										</div>
									</div>
									<div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
										<span class="mr-4">
											<i class="fa-duotone fa-list-ul icon-2x text-muted font-weight-bold"></i>
										</span>
										<div class="d-flex flex-column text-dark-75">
											<a class="font-weight-bolder font-size-sm"
												(click)="openAdicionales(adicionalesModal)">Adicionales</a>
											<span class="font-weight-bolder font-size-h5"> <span
													class="text-dark-50 font-weight-bold">$</span>{{
												planActual.adicionales | number : "1." }}</span>
										</div>
									</div>
									<!--end: Item-->
									<!--begin: Item-->
									<div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
										<span class="mr-4">
											<i class="fa-duotone fa-user-bounty-hunter icon-2x"></i>
										</span>
										<div class="d-flex flex-column flex-lg-fill">
											<span class="text-dark-75 font-weight-bolder font-size-sm">{{
												planActual.currentUsuarios }} / {{ planActual.maxUsuarios }}
												Usuarios</span>
											<a class="text-primary font-weight-bolder" (click)="openUsuarios()">Ver</a>
										</div>
									</div>
									<div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
										<span class="mr-4">
											<i class="fa-solid fa-file-invoice-dollar icon-2x"></i>
											<!-- <i class="fa-duotone fa-user-bounty-hunter icon-2x"></i> -->
										</span>
										<div class="d-flex flex-column flex-lg-fill">
											<span class="text-dark-75 font-weight-bolder font-size-sm">{{
												planActual.cantidadFacturas }} Facturas</span>
											<a class="text-primary font-weight-bolder"
												(click)="openFacturas(facturasModal)">Ver</a>
										</div>
									</div>
								</div>
								<!--begin: Items-->
							</div>
						</div>
					</div>
				</div>
				<!--begin::Panel Principal-->
			</div>
		</div>
	</div>
</div>
<ng-template #payPlanForm let-d="dismiss" let-c="close">
	<div class="modal-xl">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Pago del Plan</div>
				<div class="modal-wizard-desc">Seleccione según corresponda</div>
			</div>
		</div>
		<div class="modal-body">
			<div class="row mt-4">
				<div class="col-8">
					<app-planes-bloque *ngIf="planActual && planes" [planes]="planes" [type]="'extend'"
						[planSeleccionado]="planSeleccionado" [planUsuario]="planActual"
						(actualizarPlan)="updatePlan($event)"></app-planes-bloque>
					<div class="card border-width-3 mt-3 border-radius-0 border-color-hover-dark">
						<div class="card-body">
							<p class="mr-2">Datos para emisión de la factura:</p>
							<div *ngIf="datosFacturacion">
								<div class="row">
									<div class="col-5">
										<ng-select class="comboEmpresa" [items]="rowsDatosFacturacion"
											[clearable]="false" placeholder="Seleccione Empresa" bindLabel="razonSocial"
											[(ngModel)]="datosFacturacion"> </ng-select>
									</div>
									<div class="col-7">
										<div class="ml-4" style="display: flex">
											<div>
												<p>RUT: {{ datosFacturacion.rut }}-{{ datosFacturacion.dv }}</p>
												<p>Comuna: {{ datosFacturacion.comuna }}</p>
												<p>Giro: {{ datosFacturacion.giro }}</p>
											</div>
											<div class="ml-4">
												<p>Razón Social: {{ datosFacturacion.razonSocial }}</p>

												<p>Dirección: {{ datosFacturacion.dirFact }}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div *ngIf="planActual" class="card border-width-3 mt-3 border-radius-0 border-color-hover-dark"
						data-plugin-sticky
						data-plugin-options="{'minWidth': 991, 'containerSelector': '.row', 'padding': {'top': 85}}">
						<div class="card-body" *ngIf="nuevaFechaCaducidad && nuevaFechaCaducidad.isBefore(fechaActual)">
							<p>
								Tu plan actual terminó el {{ planActual.fechaCaducidad | date : "dd/MM/y" }}. Su nueva
								vigencia sería hasta el <strong>{{ nuevaFechaCaducidad.format("DD/MM/YYYY") }}</strong>.
								El tiempo se calcula desde el vencimiento de tu plan.
							</p>
							<p *ngIf="nuevaFechaCaducidad.isBefore(fechaActual)" style="color: red">Con este pago
								regularizas tu plan, pero aún mantendrías una mora de {{
								nuevaFechaCaducidad.diff(fechaActual, "days") * -1 }} días.</p>
							<p *ngIf="resumenCuenta && resumenCuenta.proporcional > 0">El valor total del plan tiene un
								cobro adicional de {{ resumenCuenta.proporcional | currency : "$ " : "symbol" : "1.0-0"
								: "es" }} que corresponde al proporcional del plan desde el
								{{resumenCuenta.fechaInicioProporcional | date: "dd/MM/yyyy"}} hasta el {{
								nuevaFechaCaducidad.format("DD/MM/YYYY") }}. Es decir, su plan por
								{{resumenCuenta.meses}} meses terminaría el {{resumenCuenta.fechaInicioProporcional |
								date: "dd/MM/yyyy"}} pero se agregó el cobro proporcional para cerrar el ciclo de
								facturación el día {{nuevaFechaCaducidad.format("DD/MM/YYYY")}}</p>
						</div>
						<div class="card-body" *ngIf="nuevaFechaCaducidad && nuevaFechaCaducidad.isAfter(fechaActual)">
							<p>
								Tu plan actual termina el {{ planActual.fechaCaducidad | date : "dd/MM/y" }}. Su nueva
								vigencia sería hasta el <strong>{{ nuevaFechaCaducidad.format("DD/MM/YYYY") }}</strong>
							</p>
							<p *ngIf="resumenCuenta && resumenCuenta.proporcional > 0">El valor total del plan tiene un
								cobro adicional de {{ resumenCuenta.proporcional | currency : "$ " : "symbol" : "1.0-0"
								: "es" }} que corresponde al proporcional del plan desde el
								{{resumenCuenta.fechaInicioProporcional | date: "dd/MM/yyyy"}} hasta el {{
								nuevaFechaCaducidad.format("DD/MM/YYYY") }}. Es decir, su plan por
								{{resumenCuenta.meses}} meses terminaría el {{resumenCuenta.fechaInicioProporcional |
								date: "dd/MM/yyyy"}} pero se agregó el cobro proporcional para cerrar el ciclo de
								facturación el día {{nuevaFechaCaducidad.format("DD/MM/YYYY")}}</p>
						</div>
					</div>
				</div>
				<div class="col-4">
					<app-resumen-bloque *ngIf="planActual && certificaciones" [planSeleccionado]="planSeleccionado"
						[certificaciones]="certificaciones" [type]="'extend'" [planUsuario]="planActual"
						(actualizarResumen)="notifyResumen($event)" [planes]="planes"></app-resumen-bloque>
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<div style="display: flex; align-items: center; flex-flow: row">
				<small>Si necesita emitir la factura a nombre de otra empresa, contacte con soporte antes de hacer el
					pago.</small>
				<button type="button" class="btn ml-4 btn-primary" (click)="pagar('payment')"
					id="pagarPlanSeleccionado">Pagar plan seleccionado</button>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #extendPlanForm let-d="dismiss" let-c="close">
	<div class="modal-xl">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Extender Plan</div>
				<div class="modal-wizard-desc">Seleccione según corresponda</div>
			</div>
		</div>
		<div class="modal-body">
			<div class="row mt-4">
				<div class="col-8">
					<app-planes-bloque *ngIf="planActual && planes" [planes]="planes" [type]="'extend'"
						[planSeleccionado]="planSeleccionado" [planUsuario]="planActual"
						(actualizarPlan)="updatePlan($event)"></app-planes-bloque>
					<div class="card border-width-3 mt-3 border-radius-0 border-color-hover-dark">
						<div class="card-body">
							<p class="mr-2">Datos para emisión de la factura:</p>
							<div *ngIf="datosFacturacion">
								<div class="row">
									<div class="col-5">
										<ng-select class="comboEmpresa" [items]="rowsDatosFacturacion"
											[clearable]="false" placeholder="Seleccione Empresa" bindLabel="razonSocial"
											[(ngModel)]="datosFacturacion"> </ng-select>
									</div>
									<div class="col-7">
										<div class="ml-4" style="display: flex">
											<div>
												<p>RUT: {{ datosFacturacion.rut }}-{{ datosFacturacion.dv }}</p>
												<p>Comuna: {{ datosFacturacion.comuna }}</p>
												<p>Giro: {{ datosFacturacion.giro }}</p>
											</div>
											<div class="ml-4">
												<p>Razón Social: {{ datosFacturacion.razonSocial }}</p>

												<p>Dirección: {{ datosFacturacion.dirFact }}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div *ngIf="planActual" class="card border-width-3 mt-3 border-radius-0 border-color-hover-dark"
						data-plugin-sticky
						data-plugin-options="{'minWidth': 991, 'containerSelector': '.row', 'padding': {'top': 85}}">
						<div class="card-body" *ngIf="nuevaFechaCaducidad && nuevaFechaCaducidad.isBefore(fechaActual)">
							Tu plan actual terminó el {{ planActual.fechaCaducidad | date : "dd/MM/y" }}. Su nueva
							vigencia sería hasta el <strong>{{ nuevaFechaCaducidad.format("DD/MM/YYYY") }}</strong>. El
							tiempo se calcula desde el vencimiento de tu plan.

							<p *ngIf="nuevaFechaCaducidad.isBefore(fechaActual)" style="color: red">Con este pago
								regularizas tu plan, pero aún mantendrías una mora de {{
								nuevaFechaCaducidad.diff(fechaActual, "days") * -1 }} días.</p>
							<p *ngIf="resumenCuenta && resumenCuenta.proporcional > 0">El valor total del plan tiene un
								cobro adicional de {{ resumenCuenta.proporcional | currency : "$ " : "symbol" : "1.0-0"
								: "es" }} que corresponde al proporcional del plan desde el
								{{resumenCuenta.fechaInicioProporcional | date: "dd/MM/yyyy"}} hasta el {{
								nuevaFechaCaducidad.format("DD/MM/YYYY") }}. Es decir, su plan por
								{{resumenCuenta.meses}} meses terminaría el {{resumenCuenta.fechaInicioProporcional |
								date: "dd/MM/yyyy"}} pero se agregó el cobro proporcional para cerrar el ciclo de
								facturación el día {{nuevaFechaCaducidad.format("DD/MM/YYYY")}}</p>
						</div>
						<div class="card-body" *ngIf="nuevaFechaCaducidad && nuevaFechaCaducidad.isAfter(fechaActual)">
							Tu plan actual termina el {{ planActual.fechaCaducidad | date : "dd/MM/y" }}. Su nueva
							vigencia sería hasta el <strong>{{ nuevaFechaCaducidad.format("DD/MM/YYYY") }}</strong>
							<p *ngIf="resumenCuenta && resumenCuenta.proporcional > 0">El valor total del plan tiene un
								cobro adicional de {{ resumenCuenta.proporcional | currency : "$ " : "symbol" : "1.0-0"
								: "es" }} que corresponde al proporcional del plan desde el
								{{resumenCuenta.fechaInicioProporcional | date: "dd/MM/yyyy"}} hasta el {{
								nuevaFechaCaducidad.format("DD/MM/YYYY") }}. Es decir, su plan por
								{{resumenCuenta.meses}} meses terminaría el {{resumenCuenta.fechaInicioProporcional |
								date: "dd/MM/yyyy"}} pero se agregó el cobro proporcional para cerrar el ciclo de
								facturación el día {{nuevaFechaCaducidad.format("DD/MM/YYYY")}}</p>
						</div>
					</div>
					<div *ngIf="planActual && resumenCuenta && hasAdicionales"
						class="card border-width-3 mt-3 border-radius-0 border-color-hover-dark" data-plugin-sticky
						data-plugin-options="{'minWidth': 991, 'containerSelector': '.row', 'padding': {'top': 85}}">
						<div class="card-body">Los adicionales agregados empezarán a funcionar el {{
							planActual.fechaCaducidad | date : "dd/MM/y" }}. Si requieres los adicionales antes, puedes
							ponerte en contacto con el área comercial.</div>
					</div>
					<div class="card-body card border-width-3 mt-3 border-radius-0 border-color-hover-dark">
						<div>Para transferencias:</div>
						<div>Banco BCI</div>
						<div>Cuenta Corriente N° 63211980</div>
						<div>RUT: 76.269.769-6</div>
						<div>Servicios Informáticos Gonzalo Alejandro Bustamante Banados EIRL</div>
						<div>pagos@chilesystems.com</div>
					</div>
				</div>
				<div class="col-4">
					<app-resumen-bloque *ngIf="planActual && certificaciones" [planSeleccionado]="planSeleccionado"
						[certificaciones]="certificaciones" [type]="'extend'" [planUsuario]="planActual"
						(actualizarResumen)="notifyResumen($event)" [planes]="planes"
						(actualizarCertificaciones)="actualizarCertificaciones($event)"></app-resumen-bloque>
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<div style="display: flex; align-items: center; flex-flow: row">
				<small>Si necesita emitir la factura a nombre de otra empresa, contacte con soporte antes de hacer el
					pago.</small>
				<button type="button" class="btn ml-4 btn-primary" (click)="pagar('extend')" id="extenderPlan2">Extender
					Plan</button>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #changePlanForm let-d="dismiss" let-c="close">
	<div class="modal-xl">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Nuevo Plan</div>
				<div class="modal-wizard-desc">Seleccione según corresponda para la empresa {{
					currentEmisorObject.razonSocial }}</div>
			</div>
		</div>
		<div class="modal-body">
			<div class="row mt-4">
				<div class="col-8">
					<app-planes-bloque *ngIf="planActual && planes" [planes]="planes" [type]="'change'"
						[planSeleccionado]="planSeleccionado" [planUsuario]="planActual"
						(actualizarPlan)="updatePlan($event)"></app-planes-bloque>

					<div *ngIf="planActual" class="card border-width-3 mt-3 border-radius-0 border-color-hover-dark"
						data-plugin-sticky
						data-plugin-options="{'minWidth': 991, 'containerSelector': '.row', 'padding': {'top': 85}}">
						<div class="card-body" *ngIf="nuevaFechaCaducidad && nuevaFechaCaducidad.isAfter(fechaActual)">
							<p>
								Tu plan actual <b>{{ planActual.nombrePlan }}</b> termina el {{
								planActual.fechaCaducidad | date : "dd/MM/y" }}.
							</p>
							<p *ngIf="planSeleccionado.id != planActual.idPlanSf && resumenCuenta.abono == 0">
								El nuevo plan comenzaría desde hoy y estaría vigente hasta el <strong>{{
									nuevaFechaCaducidad.format("DD/MM/YYYY") }}</strong>. Esto significa que las
								capacidades de tu plan actual se mantendrán y se sumarán las del nuevo plan. En caso de
								existir DTEs adicionales, se cobrarán según tu plan más alto (y por ende, el valor más
								económico de DTE adicional)
							</p>
							<div *ngIf="resumenCuenta && resumenCuenta.abono > 0">
								<p>
									El nuevo plan <strong>{{planSeleccionado.nombre}}</strong> comenzará a regir desde hoy <strong>{{ fechaActual.format('DD/MM/YYYY') }}</strong> y estará vigente hasta el <strong>{{ nuevaFechaCaducidad.format('DD/MM/YYYY') }}</strong>.
								</p>
								<p>
									El dinero que ya pagaste por tu plan anterior será considerado como abono para este cambio de plan.
								</p>
								<p>
									El abono será calculado por el período comprendido desde el <b>{{ abonoFechaInicio.format('DD/MM/YYYY') }}</b> hasta el <b>{{ abonoFechaFin.format('DD/MM/YYYY') }}</b>, es decir, solo se considerarán los meses completos no utilizados.
								</p>
								<p>
									El monto abonado corresponde a <b>${{ resumenCuenta.abono | number:'1.0-0':'es' }} ({{ resumenCuenta.mesesAbono }} meses)</b>.
								</p>
							</div>

							<p
								*ngIf="planSeleccionado.id != planActual.idPlanSf && nuevaFechaCaducidad.isBefore(planActual.fechaCaducidad) && planSeleccionado.maxDte != -1 && resumenCuenta.abono == 0">
								Tu plan actual: <b>{{ planActual.maxDte | number : "1." }}</b> DTEs. Nuevo plan: <b>{{
									planSeleccionado.maxDte | number : "1." }}</b> DTEs. Esto significa que tendrás
								planes en paralelo, y podrás emitir hasta <b>{{ planActual.maxDte +
									planSeleccionado.maxDte | number : "1." }}</b> DTEs al mes hasta el {{
								nuevaFechaCaducidad.format("DD/MM/YYYY") }}. Después de esta fecha seguirás con tu plan
								original <b>{{ planActual.nombrePlan }}</b>.
							</p>
							<p
								*ngIf="planSeleccionado.id != planActual.idPlanSf && nuevaFechaCaducidad.isBefore(planActual.fechaCaducidad) && planSeleccionado.maxDte == -1 && resumenCuenta.abono == 0">
								Tu plan actual: <b>{{ planActual.maxDte | number : "1." }}</b> DTEs. Nuevo plan: <b>DTE
									Ilimitados</b>. Esto significa que tendrás planes en paralelo, y podrás emitir sin
								límite hasta el {{ nuevaFechaCaducidad.format("DD/MM/YYYY") }}. Después de esta fecha
								seguirás con tu plan original <b>{{ planActual.nombrePlan }}</b>.
							</p>
							<p
								*ngIf="planSeleccionado.id != planActual.idPlanSf && nuevaFechaCaducidad.isAfter(planActual.fechaCaducidad) && planSeleccionado.maxDte != -1 && resumenCuenta.abono == 0">
								Tu plan actual: <b>{{ planActual.maxDte | number : "1." }}</b> DTEs. Nuevo plan: <b>{{
									planSeleccionado.maxDte | number : "1." }}</b> DTEs. Esto significa que podrás
								emitir hasta <b>{{ planActual.maxDte + planSeleccionado.maxDte | number : "1." }}</b>
								DTEs al mes hasta el {{ planActual.fechaCaducidad | date : "dd/MM/y" }}. Después de esta
								fecha seguirás con el plan que estás adquiriendo ahora y tu plan actual será dado de
								baja.
							</p>
							<p
								*ngIf="planSeleccionado.id != planActual.idPlanSf && nuevaFechaCaducidad.isAfter(planActual.fechaCaducidad) && planSeleccionado.maxDte == -1 && resumenCuenta.abono == 0">
								Tu plan actual: <b>{{ planActual.maxDte | number : "1." }}</b> DTEs. Nuevo plan: <b>DTE
									Ilimitados</b>. Esto significa que podrás emitir DTEs sin límite desde ahora hasta
								la finalización de tu plan. Tu plan actual será dado de baja.
							</p>
						</div>
					</div>
				</div>
				<div class="col-4">
					<app-resumen-bloque *ngIf="planActual && certificaciones" [planSeleccionado]="planSeleccionado"
						[certificaciones]="certificaciones" [type]="'change'" [planUsuario]="planActual"
						(actualizarResumen)="notifyResumen($event)" [planes]="planes" [planActualNuevo]="planActualNuevo"></app-resumen-bloque>
					<!-- <div class="card border-width-3 mt-3 border-radius-0 border-color-hover-dark">
						<div class="card-body">
							<p class="card-title">Datos para emisión de la factura:</p>
							<div *ngIf="datosFacturacion" class="datos-facturacion-container">
								<div class="combo-container">
									<ng-select class="comboEmpresa" [items]="rowsDatosFacturacion" [clearable]="false" placeholder="Seleccione Empresa" bindLabel="razonSocial" [(ngModel)]="datosFacturacion"> </ng-select>
								</div>
								<div class="info-container">
									<div class="info">
										<p>RUT: {{ datosFacturacion.rut }}-{{ datosFacturacion.dv }}</p>
										<p>Comuna: {{ datosFacturacion.comuna }}</p>
										<p>Giro: {{ datosFacturacion.giro }}</p>
									</div>
									<div class="info ml-4">
										<p>Razón Social: {{ datosFacturacion.razonSocial }}</p>
										<p>Dirección: {{ datosFacturacion.dirFact }}</p>
									</div>
								</div>
							</div>
						</div>
					</div> -->
					<div class="card border-width-3 mt-3 border-radius-0 border-color-hover-dark">
						<div class="card-body"  *ngIf="datosFacturacion">
							<p class="card-title">Facturar al RUT: {{ datosFacturacion.rut }}-{{ datosFacturacion.dv }}
							</p>
							<div class="datos-facturacion-container">
								<ng-select class="comboEmpresa" [items]="rowsDatosFacturacion" [clearable]="false"
									placeholder="Seleccione Empresa" bindLabel="razonSocial"
									[(ngModel)]="datosFacturacion"> </ng-select>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12"></div>
			</div>
		</div>
		<div class="modal-footer">
			<div style="display: flex; align-items: center; flex-flow: row" *ngIf="planActual && planSeleccionado">
				<small>Si necesita emitir la factura a nombre de otra empresa, contacte con soporte antes de hacer el
					pago.</small>
				<button type="button" id="cambiarPlan" class="btn ml-4 btn-primary"
					[ngClass]="{ 'disabled-link': planActual.idPlanSf == planSeleccionado.id }"
					(click)="planActual.idPlanSf == planSeleccionado.id ? null : pagar('change')">Cambiar Plan</button>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #facturasModal let-d="dismiss">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title" id="exampleModalLabel1">Facturas asociadas al plan</h5>
		</div>
		<div class="heading-elements mt-0"></div>
		<div class="modal-body">
			<div class="modal-body">
				<div class="form-group row mx-auto" style="align-items: baseline">
					<table class="table table-bordered">
						<thead>
							<tr>
								<th>Fecha de Emisión</th>
								<th>Folio</th>
								<th>Total</th>
								<th>Fecha de Pago</th>
								<th>Opciones</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let item of facturasPlan">
								<td>
									{{ item.fechaEmision | date : "dd/MM/y" }}
								</td>
								<td>
									{{ item.folio }}
								</td>
								<td>${{ item.total | number : "1." }}</td>
								<td>
									{{ item.fechaPago | date : "dd/MM/y HH:mm" }}
								</td>
								<td>
									<a [routerLink]="" (click)="openPDF(item.facturaId)" title="Descarga Documento"
										ngbTooltip="Descarga Documento" class="success edit mr-1 mrless">
										<div class="icon-circle bg-danger text-center align-middle pt-file-button">
											<fa-icon icon="file-pdf" class="fa-lg text-white"></fa-icon>
										</div>
									</a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="modal-footer">
				<alert id="alert-errormodal"></alert>
				<div class="form-group position-relative has-icon-left mb-0">
					<button type="button" class="btn btn-success" data-dismiss="modal"
						(click)="d('Cross click')">Volver</button>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #adicionalesModal let-d="dismiss">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title" id="exampleModalLabel1">Adicionales vigentes</h5>
		</div>
		<div class="heading-elements mt-0"></div>
		<div class="modal-body">
			<div class="modal-body">
				<div class="form-group row mx-auto" style="align-items: baseline">
					<table class="table table-bordered">
						<thead>
							<tr>
								<th>Nombre</th>
								<th>Descripción</th>
								<th>Fecha Inicio</th>
								<th>Fecha Término</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let item of adicionales">
								<td style="min-width: 260px">
									{{ item.nombre }}
								</td>
								<td>
									{{ item.descripcion }}
								</td>
								<td style="min-width: 110px">
									{{ item.fechaInicio | date : "dd/MM/y" }}
								</td>
								<td style="min-width: 115px">
									{{ item.fechaTermino | date : "dd/MM/y" }}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="modal-footer">
				<alert id="alert-errormodal"></alert>
				<div class="form-group position-relative has-icon-left mb-0">
					<button type="button" class="btn btn-success" data-dismiss="modal"
						(click)="d('Cross click')">Volver</button>
				</div>
			</div>
		</div>
	</div>
</ng-template>